import React, { Component } from 'react';
import { _post, _getToken, variable } from './Function';
import { Link } from "react-router-dom";
import '../css/SideBar.css';

class SideBar extends Component {
    constructor(props) {
        super(props);
        this.state={ 
            lastlogin: '', 
            is_lastlogin: true,
            is_message: true,
            badge: 0,
            message: [],
            path: '/online/message/'
        }
        this.getSideBar();
    }

    componentWillReceiveProps(nextProps) {
        if ( nextProps.onRefresh ) {
            this.getSideBar();
        }
    }

    getSideBar() {
        let param = { token: _getToken(), platform: variable().platform };
        _post('web.sidebar.php', param)
        .then(res => { 
            if ( res.data.login_status ) {
                this.setState({ lastlogin: res.data.lastlogin })
            } else {
                this.setState({ is_lastlogin: false })
            }
            if ( res.data.message_status ) {
                this.setState({ badge: res.data.badge, message: res.data.data })
            } else {
                this.setState({ is_message: false })
            }
        })
        .catch(err => { });
    }

    renderBadge() {
        return(
            this.state.badge > 0 ?
            <Link to="/online/message"><span className="badges">{this.state.badge} ข้อความใหม่</span></Link> : null
        )
    }

    renderMessage() {
        return (
            <div>
                {
                    (this.state.message.length > 0) ?
                        this.state.message.map(message => (
                            <a href={this.state.path + message.msg_id} key={"side"+message.msg_id}>
                                <div className="msg-content">
                                    <div className="msg-icon">
                                        { (message.is_read ) ? <i className="far fa-envelope-open" /> : <i className="fas fa-envelope" /> }
                                    </div>
                                    <div className="msg-message">
                                        {message.msg_title}
                                        <div className="msg-time">{message.create_date}</div>
                                    </div>                       
                                </div>
                            </a>
                        ))
                    :
                    <div className="no-data">ไม่พบข้อความถึงคุณ</div>
                }
            </div>
        );
    }

    render() {
        return (
            <div className="side-bar">
                <div className="card">
                    <div className="card-title">
                        <div className="card-icon"><i className="fas fa-sign-in-alt"></i></div>
                        <div className="card-title-text">เข้าใช้งานระบบล่าสุด</div>
                    </div>
                    <div className="card-content">
                        { (this.state.is_lastlogin) ? <div className="lastlogin">{this.state.lastlogin}</div> : <div className="no-data">ไม่พบการเข้าใช้งานล่าสุด</div> }
                    </div>
                </div>
                <div className="card">
                    <div className="card-title">
                        <div className="card-icon">
                        <i className="fas fa-envelope"></i>
                        </div>
                        <div className="card-title-text">ข้อความถึงท่าน</div>
                        {this.renderBadge()}
                    </div>
                    <div className="card-content msg-card-content">
                        {this.renderMessage()}
                        {
                            (this.state.message.length > 0) ?
                                <div className="msg-all"><Link to="/online/message"><span>ข้อความทั้งหมด</span></Link></div>
                            :
                                null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default SideBar;